import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { CookieModule, CookieService } from 'ngx-cookie';

import { AoiToolComponent } from './aoi-tool/aoi-tool.component';
import { Api } from './api/api';
import { GisToolsApi } from './api/gis-tools-api';
import { Http2Factory } from './api/http2-factory';
import { AppComponent } from './app.component';
import { DrawToolComponent } from './draw-tool/draw-tool.component';
import { HomeComponent } from './home/home.component';
import { IdentifyToggleComponent } from './identify-toggle/identify-toggle.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { BasicBridgeReportComponent } from './reports/report-components/basicBridgeReport/basicBridgeReport';
import { BridgeDataReportComponent } from './reports/report-components/bridgeDataReport/bridgeDataReport';
import { DetailBridgeReportComponent } from './reports/report-components/detailBridgeReport/detailBridgeReport';
import { HopDetailReportComponent } from './reports/report-components/hopDetailReport/hopDetailReport';
import { IRIProjectEvaluationDraftTIPReportComponent } from './reports/report-components/iriProjectEvaluationDraftTipReport/iriProjectEvaluationDraftTipReport';
import { IRIProjectEvaluationTIPReportComponent } from './reports/report-components/iriProjectEvaluationTipReport/iriProjectEvaluationTipReport';
import { LegislativeAssetDraftTipReportComponent } from './reports/report-components/legislativeAssetDraftTipReport/legislativeAssetDraftTipReport';
import { LegislativeAssetTipReportComponent } from './reports/report-components/legislativeAssetTipReport/legislativeAssetTipReport';
import { MunicipalityAssetDraftTipReportComponent } from './reports/report-components/municipalityAssetDraftTipReport/municipalityAssetDraftTipReport';
import { MunicipalityAssetTipReportComponent } from './reports/report-components/municipalityAssetTipReport/municipalityAssetTipReport';
import { OPIProjectEvaluationDraftTIPReportComponent } from './reports/report-components/opiProjectEvaluationDraftTipReport/opiProjectEvaluationDraftTipReport';
import { OPIProjectEvaluationTIPReportComponent } from './reports/report-components/opiProjectEvaluationTipReport/opiProjectEvaluationTipReport';
import { PlanningStatsDraftTipReportComponent } from './reports/report-components/planningStatsDraftTipReport/planningStatsDraftTipReport';
import { PlanningStatsTipReportComponent } from './reports/report-components/planningStatsTipReport/planningStatsTipReport';
import { ProjectDetailReportComponent } from './reports/report-components/projectDetailReport/projectDetailReport';
import { ProjectListReportComponent } from './reports/report-components/projectListReport/projectListReport';
import { ProjectStatusReportComponent } from './reports/report-components/projectStatusReport/projectStatusReport';
import { SDBridgeReportComponent } from './reports/report-components/sdBridgeReport/sdBridgeReport';
import { SDBridgeSummaryReportComponent } from './reports/report-components/sdBridgeSummaryReport/sdBridgeSummaryReport';
import { ReportHelper } from './reports/report-helper';
import { ReportLauncher } from './reports/report-launcher';
import { ReportListComponent } from './reports/report-list.component';
import { SearchTipsComponent } from './search-tips/search-tips.component';

@NgModule({
    declarations: [
        AppComponent,
        IdentifyToggleComponent,
        NavMenuComponent,
        SearchTipsComponent,
        HomeComponent,
        DrawToolComponent,
        ReportListComponent,
        BasicBridgeReportComponent,
        BridgeDataReportComponent,
        ProjectListReportComponent,
        DetailBridgeReportComponent,
        HopDetailReportComponent,
        IRIProjectEvaluationDraftTIPReportComponent,
        IRIProjectEvaluationTIPReportComponent,
        LegislativeAssetDraftTipReportComponent,
        LegislativeAssetTipReportComponent,
        MunicipalityAssetDraftTipReportComponent,
        MunicipalityAssetTipReportComponent,
        OPIProjectEvaluationDraftTIPReportComponent,
        OPIProjectEvaluationTIPReportComponent,
        PlanningStatsDraftTipReportComponent,
        PlanningStatsTipReportComponent,
        ProjectDetailReportComponent,
        ProjectStatusReportComponent,
        SDBridgeReportComponent,
        SDBridgeSummaryReportComponent,
        AoiToolComponent
    ],
    imports: [
        BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
        HttpClientModule,
        FormsModule,
        CookieModule.forRoot(),
        RouterModule.forRoot([
            { path: 'projectListReport/:id', component: ProjectListReportComponent},
            { path: 'basicBridgeReport/:id', component: BasicBridgeReportComponent},
            { path: 'bridgeDataReport/:id', component: BridgeDataReportComponent},
            { path: 'detailBridgeReport/:id', component: DetailBridgeReportComponent},
            { path: 'hopDetailReport/:id', component: HopDetailReportComponent},
            { path: 'iriProjectEvaluationDraftTipReport/:id', component: IRIProjectEvaluationDraftTIPReportComponent},
            { path: 'iriProjectEvaluationTipReport/:id', component: IRIProjectEvaluationTIPReportComponent},
            { path: 'legislativeAssetDraftTipReport/:id', component: LegislativeAssetDraftTipReportComponent},
            { path: 'legislativeAssetTipReport/:id', component: LegislativeAssetTipReportComponent},
            { path: 'municipalityAssetDraftTipReport/:id', component: MunicipalityAssetDraftTipReportComponent},
            { path: 'municipalityAssetTipReport/:id', component: MunicipalityAssetTipReportComponent},
            { path: 'opiProjectEvaluationDraftTipReport/:id', component: OPIProjectEvaluationDraftTIPReportComponent},
            { path: 'opiProjectEvaluationTipReport/:id', component: OPIProjectEvaluationTIPReportComponent},
            { path: 'planningStatsDraftTipReport/:id', component: PlanningStatsDraftTipReportComponent},
            { path: 'planningStatsTipReport/:id', component: PlanningStatsTipReportComponent},
            { path: 'projectDetailReport/:id', component: ProjectDetailReportComponent},
            { path: 'projectStatusReport/:id', component: ProjectStatusReportComponent},
            { path: 'sdBridgeReport/:id', component: SDBridgeReportComponent},
            { path: 'sdBridgeSummaryReport/:id', component: SDBridgeSummaryReportComponent},
            { path: '', component: HomeComponent, pathMatch: 'full' }
        ])
    ],
    providers: [
        Api,
        Http2Factory,
        GisToolsApi,
        ReportHelper,
        ReportLauncher,
        HomeComponent,
        CookieService,
        {provide: LocationStrategy, useClass: PathLocationStrategy}
    ],
    bootstrap: [AppComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})
export class AppModule { }
